var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import InfoIcon from '@mui/icons-material/Info';
import MuiTooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
var TooltipStyled = styled(MuiTooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  font-size: 1.5rem;\n\n  .MuiTooltip .tooltip {\n    font-size: 3rem;\n  }\n"], ["\n  cursor: pointer;\n  font-size: 1.5rem;\n\n  .MuiTooltip .tooltip {\n    font-size: 3rem;\n  }\n"])));
var TooltipContent = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1rem;\n"], ["\n  font-size: 1rem;\n"])));
export var Tooltip = function (_a) {
    var _b = _a.Icon, Icon = _b === void 0 ? InfoIcon : _b, _c = _a.content, content = _c === void 0 ? '' : _c, _d = _a.contentProps, contentProps = _d === void 0 ? {} : _d, _e = _a.placement, placement = _e === void 0 ? 'bottom' : _e, props = __rest(_a, ["Icon", "content", "contentProps", "placement"]);
    var renderTooltipContent = function () { return (<TooltipContent data-testid="tooltip-content" {...contentProps}>
      {content}
    </TooltipContent>); };
    return (<TooltipStyled data-testid="tooltip" arrow title={renderTooltipContent()} placement={placement} {...props}>
      <Icon />
    </TooltipStyled>);
};
var templateObject_1, templateObject_2;
